export class AppConstant {    
    static mapboxToken  = "pk.eyJ1Ijoia2FubmFuZzg4IiwiYSI6ImNsY2RxbndxODcwdzczd2tleHV5ZHIyangifQ.dIgJJ6jB1pA1qqDTeUc0gQ"; // Set your mapbox token here
}